'use client';

import { createContext, useContext } from 'react';

import type { Brand } from '~/lib/brand';

const BrandContext = createContext<Brand>('flow');

interface BrandProviderProps {
  brand: Brand;
  children: React.ReactNode;
}

export function BrandProvider({ brand, children }: BrandProviderProps) {
  return (
    <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
  );
}

/**
 * Get the current brand in client components.
 *
 * Returns 'ballee' or 'flow' based on the hostname detected by middleware.
 */
export function useBrand(): Brand {
  return useContext(BrandContext);
}
